<label>
  <span class="icon material-icons">lock</span>
  {{ 'reward.status.locked' | translate }}
</label>
